import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class Heroes extends Request {
  constructor(seriesId, lang) {
    super()
    this.series = seriesId
    this.lang = lang
  }

  get path() {
    return '/apis/heroes'
  }

  get method() {
    return Methods.post
  }

  get parameters() {
    const params = {}
    params.series_id = this.series
    return params
  }

  decode({ data }) {
    const _data = []
    if (this.lang !== 'zh-TW') {
      for (const key in data) {
        if(typeof(data[key]) === 'object'){
          const item = {}
          item[key] = data[key].map(d => new ModelHero(d))
          _data.push(item)
        }
      }
    } else {
      const item = {}
      item.noIndex = data.map(d => new ModelHero(d))
      _data.push(item)
    }
    
    return _data
  }

  decodeError(error) {
    return { error: error }
  }
}
